// extracted by mini-css-extract-plugin
export default {"title":"RegisterCoursePopup_title__dmqke","action":"RegisterCoursePopup_action__viHUe"};